var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaitTimeHeaderBlobMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 678,
    height: 69,
    viewBox: "0 0 678 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M677.48 69H1.86214e-06C71.6609 23.7775 193.907 0 330.948 0C366.505 0 403.058 1.60072 439.981 4.8429C554.231 14.8566 632.812 37.1331 677.48 69Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitTimeHeaderBlobMask);
export default __webpack_public_path__ + "static/media/wait-time-header-blob-mask.33c2f3437385106e0c5c12d3b6440cc0.svg";
export { ForwardRef as ReactComponent };